/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/
import { StyledDataGrid } from "../../Style/trivial/StyledDataGrid";
import is_not_empty from "../../App/validation/is_not_empty";
import dict from "../../Data/dict.json";

/*DATA*/

/*CONST*/
const language = localStorage?.language || "ina";

// Helper function to detect if a value is an image URL
const isImageUrl = (value) => {
  if (typeof value !== "string") return false;
  const imageExtensions = [
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".bmp",
    ".webp",
    ".svg",
  ];
  const lowerValue = value.toLowerCase().trim();
  return imageExtensions.some((ext) => lowerValue.endsWith(ext));
};

class DataTypeConfirmation extends Component {
  handle_data_type = ({ field, value }) => {
    const { set_target_data_types } = this.props;
    let target_data_types = structuredClone(this.props.target_data_types) || [];
    const idx = target_data_types.findIndex((item) => item.fields === field);
    if (idx !== -1) {
      target_data_types[idx]["dataType"] = value;
      set_target_data_types(target_data_types);
    }
  };

  componentDidUpdate = (prevProps) => {
    if (JSON.stringify(prevProps.file) !== JSON.stringify(this.props.file)) {
      const { set_target_data_types } = this.props;
      const file = this.props.file;

      let result = [];
      file?.headers?.forEach((key, index) => {
        const no = index + 1;
        result.push({
          id: no,
          no: no,
          fields: key,
          dataType: "text",
          nan: 0,
          empty: 0,
        });
      });

      // Detect data types based on first row
      file?.headers?.forEach((field) => {
        const idx = result.findIndex((item) => item.fields === field);
        if (idx !== -1) {
          const firstValue = file.data?.features?.[0]?.["properties"][field];

          // Check if it's an image URL
          if (isImageUrl(firstValue)) {
            result[idx]["dataType"] = "image";
          }
          // Check if it's a number
          else if (!isNaN(firstValue) && is_not_empty(firstValue)) {
            result[idx]["dataType"] = "number";
          }
        }
      });

      // Count NaN and empty values
      file.data?.features?.forEach((feature) => {
        file?.headers?.forEach((field) => {
          const idx = result.findIndex((item) => item.fields === field);
          if (idx !== -1) {
            const value = feature?.["properties"][field];

            // cari nan value dan type data (text/number)
            if (isNaN(value)) {
              result[idx]["nan"] += 1;
            }

            // cari value kosong (null, undefined)
            if (!is_not_empty(value)) {
              result[idx]["empty"] += 1;
            }
          }
        });
      });

      set_target_data_types(result);
    }
  };

  get_columns = () => {
    return [
      {
        field: "no",
        headerName: "No.",
        editable: false,
        flex: 1,
        type: "number",
      },
      {
        field: "fields",
        headerName: "Fields",
        editable: false,
        flex: 3,
      },
      {
        field: "dataType",
        headerName: "Data Types",
        editable: false,
        flex: 2,
        renderCell: (params) => {
          const field = params?.row?.fields;
          const value = params?.formattedValue;

          const selection = (
            <select
              className="dropdown_in_table"
              value={value}
              onChange={(e) => {
                this.handle_data_type({ field, value: e.target.value });
              }}
            >
              <option value={"number"}>{dict?.["Number"]?.[language]}</option>
              <option value={"text"}>{dict?.["Text"]?.[language]}</option>
              <option value={"image"}>
                {dict?.["Image"]?.[language] || "Image"}
              </option>
            </select>
          );
          return selection;
        },
      },
      {
        field: "nan",
        headerName: "NaN (Not a Number)",
        editable: false,
        flex: 2,
      },
      {
        field: "empty",
        headerName: "Empty Value",
        editable: false,
        flex: 2,
      },
    ];
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    const { target_data_types } = this.props;
    const rows_text = [];
    const rows_number = [];
    const rows_image = [];

    target_data_types?.forEach((item) => {
      if (item["dataType"] === "number") {
        rows_number.push(item);
      } else if (item["dataType"] === "image") {
        rows_image.push(item);
      } else {
        rows_text.push(item);
      }
    });

    return (
      <div className="flex flex_col gap_20 marginTop_20">
        <section>
          <label>{dict?.["Number"]?.[language]}</label>
          <StyledDataGrid
            rows={rows_number}
            columns={this.get_columns()}
            getRowHeight={() => 35}
            rowsPerPageOptions={[25, 50, 100, 500, 1000]}
            disableColumnMenu
          />
        </section>
        <section>
          <label>{dict?.["Image"]?.[language] || "Image"}</label>
          <StyledDataGrid
            rows={rows_image}
            columns={this.get_columns()}
            getRowHeight={() => 35}
            rowsPerPageOptions={[25, 50, 100, 500, 1000]}
            disableColumnMenu
          />
        </section>
        <section>
          <label>{dict?.["Text"]?.[language]}</label>
          <StyledDataGrid
            rows={rows_text}
            columns={this.get_columns()}
            getRowHeight={() => 35}
            rowsPerPageOptions={[25, 50, 100, 500, 1000]}
            disableColumnMenu
          />
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layer: state.layer,
    auth: state.auth,
  };
};
export default connect(mapStateToProps, {})(DataTypeConfirmation);
